import axios from "axios"
import store from "@/store/"
import { Notify, Dialog, Toast } from "vant"
import router from "@/router"
import { ls } from "@/utils//cache"
import { TOKEN } from "@/store/mutation-types"
import authApi from "@/api/auth"
import { isArray } from "lodash"
//默认配置
const config = {
  // eslint-disable-next-line no-undef
  serverUrl: env.API_HOST, //请求地址
  responseBody: {
    code: "Code",
    data: "Data",
    message: "Message",
    isConfirmed: "isConfirmed",
  },
  warningCode: 1, // 响应体中 警告状态的 code
  successCode: 0, // 响应体中 成功状态的 code
}

let modalOpen = false
//请求状态错误处理
const err = (error) => {
  if (error.response) {
    const status = error.response.status
    const data = error.response.data

    let msg =
      data && data[config.responseBody.message]
        ? data[config.responseBody.message]
        : ""
    if (status === 401) {
      store.dispatch("user/login").then(() => {
        window.location.reload()
      })
    } else if (status === 403) {
      msg = "您没有权限"
    } else if (status === 404) {
      msg = "api请求接口不存在"
    } else {
      msg = "请求出错"
    }
    const message =
      data && data[config.responseBody.message]
        ? data[config.responseBody.message]
        : msg

    Notify(message)
  } else if (error.code == "ECONNABORTED") {
    Notify("服务器连接超时")
  }
}

//响应体Code异常处理
// const abnormal = response => {
//   const res = response.data;
//   // 当设置 handleError 为 false 则不做异常处理
//   if (
//     response.config.headers &&
//     response.config.headers.handleError === false
//   ) {
//     return false;
//   }

//   // const resultCode = res[config.responseBody.code];
//   const description =
//     res && res[config.responseBody.message]
//       ? res[config.responseBody.message]
//       : "请求失败";
//   // let message = "abnormalCode：" + resultCode;
//   // if (resultCode === 99) {
//   //   message = "请求参数错误";
//   // }
//   Notify(description);
// };

// 创建实例
const service = axios.create({
  baseURL: env.API_HOST,
  timeout: 20000,
})

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    if (
      !(config.data && config.data.notToken) &&
      !(config.params && config.params.notToken) &&
      store.getters.token &&
      !config.headers["Authorization"]
    ) {
      config.headers["Authorization"] = store.getters.token
    }

    return config
  },
  (error) => {
    Toast.clear()
    err(error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    Toast.clear()
    return response
    // const res = response.data;
    // const resultCode = res[config.responseBody.code];
    // if (resultCode === config.warningCode) {
    //   Notify({ type: "warning", message: res.message || "" });
    //   return res;
    // } else if (
    //   resultCode === config.successCode ||
    //   response.request.responseURL.indexOf(config.serverUrl) < 0
    // ) {
    //   return res; // 成功回调
    // } else {
    //   abnormal(response);
    //   return Promise.reject(response);
    // }
  },
  (error) => {
    Toast.clear()
    err(error)
    return Promise.reject(error)
  }
)

export const sendRequest = (url, params, type, obj) => {
  const data = {
    ...obj,
    url,
    method: type,
  }
  let dataKey = type === "get" ? "params" : "data"
  data[dataKey] = params

  if (type === "form-data") {
    data.method = "post"
    const formData = new FormData()
    for (let key in params) {
      if (params[key] != undefined) {
        if (typeof params[key] == "object" && isArray(params[key])) {
          for (let i = 0; i < params[key].length; i++) {
            const item = params[key][i]
            formData.append(key + "[]", item)
          }
        } else {
          formData.append(key, params[key])
        }
      }
    }
    data.data = formData
  }

  if (
    (obj ? obj.isLoading : obj) !== false &&
    params &&
    params.ISLOADING !== false
  ) {
    Toast.loading({
      duration: 0,
      message: "加载中...",
      forbidClick: true,
    })
  }
  return requestInit(data, dataKey)
}

const requestInit = (params, dataKey) => {
  return new Promise((resolve, reject) => {
    service(params)
      .then((response) => {
        const res = response.data
        let message = res.Message || ""
        message = message.replace(/\/r|\/n/g, "\n")
        // 当设置 handleError 为 false 则不做异常处理
        if (
          response.config.headers &&
          response.config.headers.handleError === false
        ) {
          reject(res)
        }
        let code = res[config.responseBody.code]
        if (code === config.successCode || (!code && code !== 0)) {
          resolve(res)
        } else if (code === 1) {
          Notify({ type: "warning", message: message })
          resolve(res)
        } else {
          switch (code) {
            case 2:
              if (params[dataKey][config.responseBody.isConfirmed]) {
                resolve(res)
              } else {
                // 确认框(确定或取消)
                Dialog.confirm({
                  title: "提示",
                  message: message,
                })
                  .then(() => {
                    params[dataKey][config.responseBody.isConfirmed] = true
                    requestInit(params)
                      .then((res) => {
                        resolve(res)
                      })
                      .catch((res) => {
                        reject(res)
                      })
                  })
                  .catch(() => {
                    reject(res)
                  })
              }
              break
            case 3:
              Notify({ type: "danger", message: message })
              reject(res)
              break
            case 4:
              Dialog.alert({
                title: "提示",
                message: message,
              }).then(() => {
                store.dispatch("user/logout")
              })
              reject(res)
              break
            case 5:
              break
            default:
              var description =
                res && res[config.responseBody.message]
                  ? res[config.responseBody.message]
                  : "请求失败"

              Notify(description)
              reject(res)
              break
          }
        }
      })
      .catch((res) => {
        reject(res)
      })
  })
}

export default sendRequest
